<template>
    <div class="contents">
      <div class="wrap">
        <section>
          <h2 class="page_title --view">공지사항 상세</h2>
        </section>
        <section class="view">
          <div class="table_list">
            <table class="write">
              <colgroup>
                <col width="200">
                <col width="*">
              </colgroup>
              <tbody>
                <tr>
                  <th><span>제목</span></th>
                  <td>{{noticeInfo.board_notice_title}}</td>
                </tr>
                <tr>
                  <th><span>작성일자</span></th>
                  <td>{{noticeInfo.reg_dt}}</td>
                </tr>
                <tr>
                  <th><span>중요공지</span></th>
                  <td v-if="noticeInfo.board_notice_impt_yn == 'Y'">중요공지</td>
                  <td v-if="noticeInfo.board_notice_impt_yn != 'Y'">일반공지</td>
                </tr>
                <tr>
                  <th><span>공지기간</span></th>
                  <td>{{noticeInfo.board_notice_start_dt}} ~ {{noticeInfo.board_notice_end_dt}}</td>
                </tr>
                <tr>
                  <th><span>게시여부</span></th>
                  <td>{{noticeInfo.board_notice_status_nm}}</td>
                </tr>
                <tr>
                  <th><span>내용</span></th>
                  <td>
                      <div v-html="noticeInfo.board_notice_cnts">                      
                      </div>
                  </td>
                </tr>
                <tr>
                  <th><span>첨부파일</span></th>
                  <td>
                    <div class="form_inline" v-if="noticeInfo.file_org_name != null && noticeInfo.file_org_name != ''">
                      <ul class="file_list">
                        <li><a href="#" @click.prevent="fn_download_file(noticeInfo.file_id)">{{noticeInfo.file_org_name}}</a></li>
                      </ul>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="bottom_box">
              <button class="btn btn_md btn_outline" @click="fn_move_list_page">목록</button>
              <div class="btn_box">
                <button class="btn btn_md btn_gray" @click="fn_del_notice">삭제</button>
                <button class="btn btn_md btn_darkblue" @click="fn_update_notice">수정</button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
</template>

<script>
  import axios from 'axios'
  import commonUtil from "@/mixin/commonUtil";

  export default {
    name: 'NoticeMngtDtl',
    mixins: [commonUtil],
    data() {
      return {
        boardNoticeId: '',
        noticeInfo : {}
      }
    },
    created(){
      this.boardNoticeId = this.$store.getters['notice/getBoardNoticeId'];
      console.log("@@@@ boardNoticeId : "+this.boardNoticeId);
      this.fn_search(this.boardNoticeId);
    },
    methods : {
        fn_search(boardNoticeId){

            let param = new Object();
            param.boardNoticeId = boardNoticeId;

            console.log("@@@@ param : %o",param);

            axios
                .post("/api/admin/board/noticeDetail", param)
                .then((res) => {
                    console.log("@@@@ res : %o",res);
                    this.noticeInfo = res.data;

                    console.log("@@@@ noticeInfo : %o",this.noticeInfo);
                })
                .catch((err) => console.log(err));
                
        },
        fn_move_list_page(){
            this.$store.dispatch('notice/setStatus', ''); 
            this.$router.push("/admin/board/noticeMngtReg");
        },
        fn_del_notice(){
            let param = new Object();
            param.boardNoticeId = this.boardNoticeId;

            axios
                .post("/api/admin/board/deleteNotice", param)
                .then((res) => {
                    alert("삭제되었습니다");
                    this.fn_move_list_page();                        
                })
                .catch((err) => console.log(err));
        },
        fn_update_notice(){
            this.$store.dispatch('notice/setBoardNoticeId', this.boardNoticeId);
            this.$router.push("/admin/board/noticeMngtReg");
        },
    }
  }
</script>